import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-arrays-group-by',
  slug: 'group-by',
  title: 'Group orders by status',
  type: 'code',
  estSeconds: 480,
  contentVersion: 1,
});
